/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import { getBizID, getServices, getStyle } from "../../libs/todoSlice"
import FadeIn from "react-fade-in/lib/FadeIn"
import { Card } from "@material-ui/core";
import { OrderList } from 'primereact/orderlist';
import fontColor from "../../lib/fontColor"
import LoadingComponent from "../../lib/LoadingComponent"
import Button from '@mui/material/Button';

export default function DipchipManagement() {
  const business_id = useSelector(getBizID)
  const params = useParams()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const services = useSelector(getServices)
  const style = useSelector(getStyle)
  useEffect(() => {
    if (!services.includes('dipchip-management')) {
      navigate(`/${params.prefix}/manage-members`)
    }
  }, [services])

  const [processes, setProcesses] = useState([]);

  useEffect(() => {
    getDipchip()
  }, [])

  const getDipchip = async () => {
    setLoading(true)
    try {
      const { data, status } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/dipchip/step/${business_id}`,
      })
      if (data.data.step.length === 0) {
        setProcesses([
          {
            label: 'กรอกเลขหลังบัตรประชาชน',
            value: 'laserCode'
          },
          {
            label: 'เสียบบัตรประจำตัวประชาชน',
            value: 'insertCard'
          },
          {
            label: 'กรอกเบอร์โทรศัพท์',
            value: 'inputTelephoneNumber'
          },
          {
            label: 'ถ่ายภาพตรวจสอบใบหน้า',
            value: 'faceCapture'
          }
        ])
      } else {
        setProcesses(data.data.step)
      }
      setLoading(false)
    } catch ({ response }) {

    }

  }

  const save = async () => {
    setLoading(true)
    const { data, status } = await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/dipchip/step`,
      data: {
        business_id: business_id,
        step: processes
      },
    })
    getDipchip()
  }


  const itemTemplate = (item) => {
    return (
      <>{item.label}</>
    );
  };


  return (
    <FadeIn>
      <div className="container">
        <div className="row">
          <div className="col text-center">
            <span
              style={{
                fontSize: '28px'
              }}
            >
              ตั้งค่ากระบวนการยืนยันตัวตนด้วยการเสียบบัตร (Dipchip)
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <Card>
              <div className="row">
                <div className="col text-center">
                  <OrderList value={processes} onChange={(e) => setProcesses(e.value)} itemTemplate={itemTemplate} header="Processes" dragdrop />
                </div>
              </div>
              <div className="row my-3">
                <div className="col text-center text-md-end mx-2">
                  <Button
                    style={{
                      backgroundColor: style.primary_color,
                      color: fontColor(style.primary_color),
                    }}
                    onClick={() => {
                      save()
                    }}
                  >
                    {loading ? <LoadingComponent width={30} height={30} /> : <>บันทึก</>}
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>

      </div>
    </FadeIn>
  )
}